import { useMemo } from "react";

import type { BulkActionTypeHandlers } from "@punto/frontend-shared/components/bulk-actions";
import { useTranslation } from "@punto/frontend-shared/i18n/i18next";
import { toast } from "@punto/ui/components/toaster";

import {
  PRINT_BUNDLE_EMPTY,
  settlePrintBundle,
} from "@/modules/bulk-actions/print-bundles";

/**
 * The delivery prints' bulk-action handlers (P-3022) — a whole delivery or one
 * of its procedures. A finished bundle downloads itself; nothing is marked
 * printed, and the panel link is a plain download.
 */
export const useDeliveryPrintHandlers = (): BulkActionTypeHandlers => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      onSettled: (action) =>
        settlePrintBundle(action, {
          onFailed: (errorMessage) => {
            if (errorMessage === PRINT_BUNDLE_EMPTY) {
              toast.info(t("DeliveriesTable.errors.print_documents_empty"));
              return;
            }
            toast.error(t("DeliveriesTable.errors.print_documents_failed"));
          },
        }),
    }),
    [t],
  );
};
